<template>
  <transition name="slide-y-transition">
    <div>
      <div class='import-explain mb-3'>
        <p>Import Rapportage</p>
      </div>

      <div style='float: right' class='mt-2'>
        <Button primary class="mr-3" @click="this.handlePrevious">
          {{ 'buttons.previous-step' | translate }}
        </Button>
        <Button positive @click="this.handleConfirm">
          Klaar
        </Button>
      </div>

    </div>
  </transition>
</template>

<script>
import Button from '@aevitae/aevitaeui/0_atoms/buttons/Button.vue';

import RosImportConstants from '@/views/constants/reports-of-sickness-import-new';

export default {
  name: 'ReportsOfSicknessImportReport',
  components: {
    Button
  },
  methods: {
    handlePrevious () {
      this.$store.dispatch(RosImportConstants.Actions.NAVIGATE, RosImportConstants.Views.ImportFile);
    },
    handleConfirm () {
      this.$store.dispatch(RosImportConstants.Actions.CANCEL);
    }
  }
};
</script>

<style lang='scss' scoped>
@import '@/assets/stylesheets/variables.scss';

</style>
